import { Analytics } from "./AnalyticsGeneral";
import { apiService } from "@/_services";
import { sum, values } from "d3";
import { formatDate_YMD, timeParseNoNull2 } from "@/_core/_helpers/_helpers";

export class AnalyticsCurrency extends Analytics {
  constructor(params) {
    super({ ...params });
  }

  parseManagementData(data, _this, calculate = true) {
    let dateFieldsManagement = [
      "date",
      "planned_expiration_date",
      "trade_date",
      "fixing_date",
      "monthDate",
    ];
    let dateFieldsExpo = [
      "date",
      "expiration_date",
      "hedged_date",
      "issue_date",
      "planned_expiration_date",
      "realized_expiration_date",
      "sale_date",
      "shipping_date",
      "updated_at",
    ];
    let dateFieldsHedge = [
      "asian_fixing_start_date",
      "fixing_date",
      "hedged_date",
      "premium_value_date",
      "trade_date",
      "value_date",
      "valuation_date",
    ];
    let dateFieldsMerged = [
      "asian_fixing_start_date",
      "created_at",
      "date",
      "eta",
      "fixation_date",
      "fixing_date",
      "hedged_date",
      "p_date",
      "premium_value_date",
      "purchase_date",
      "sale_date",
      "shipping_date",
      "trade_date",
      "updated_at",
      "value_date",
    ];
    // parse expo
    data[0].expo = this.processDataRawExpo(data[0].expo, dateFieldsExpo);
    // parse hedge
    data[0].hedge = this.processDataRawHedge(data[0].hedge, dateFieldsHedge);
    // parse date
    data[0].date.forEach(function(d) {
      for (let i = 0; i < dateFieldsManagement.length; i++) {
        d[dateFieldsManagement[i]] = timeParseNoNull2(
          d[dateFieldsManagement[i]],
        );
      }
      d.q_min_max = `${Math.round(+d.q_min)?.toLocaleString("en-US") ??
        "N/A"} | ${Math.round(+d.q_max)?.toLocaleString("en-US") ?? "N/A"}`;
    });
    // parse date_2
    data[0].date_2.forEach(function(d) {
      for (let i = 0; i < dateFieldsManagement.length; i++) {
        d[dateFieldsManagement[i]] = timeParseNoNull2(
          d[dateFieldsManagement[i]],
        );
      }
      d.q_min_max = `${Math.round(+d.q_min)?.toLocaleString("en-US") ??
        "N/A"} | ${Math.round(+d.q_max)?.toLocaleString("en-US") ?? "N/A"}`;
    });
    // parse contracts
    data[0].contracts.forEach(function(d) {
      for (let i = 0; i < dateFieldsManagement.length; i++) {
        d[dateFieldsManagement[i]] = timeParseNoNull2(
          d[dateFieldsManagement[i]],
        );
      }
      d.q_min_max = `${Math.round(+d.q_min)?.toLocaleString("en-US") ??
        "N/A"} | ${Math.round(+d.q_max)?.toLocaleString("en-US") ?? "N/A"}`;
    });
    Object.assign(_this.Analytics["rawData"], {
      expoPast: [],
    });
    Object.assign(_this.Analytics["rawData"], {
      expoFuture: [],
    });
    Object.assign(_this.Analytics["rawData"], {
      hedgesPast: [],
    });
    Object.assign(_this.Analytics["rawData"], {
      hedgesFuture: [],
    });
    Object.assign(_this.Analytics["rawData"], {
      expo: data[0].expo,
    });
    Object.assign(_this.Analytics["rawData"], {
      hedges: data[0].hedge,
    });
    Object.assign(_this.Analytics["management"], {
      strategies: data[0].strategies,
      date: data[0].date,
      date_2: data[0].date_2,
      contracts: data[0].contracts,
    });
    // parse merged
    if (
      Object.keys(data[0].mergedExpoHedges).length === 0 ||
      data[0].mergedExpoHedges.length === 0
    ) {
      this.resetData();
    } else {
      let mergedExpoHedges = this.processMergedData(
        data[0].mergedExpoHedges,
        dateFieldsMerged,
      );
      Object.assign(this.rawData, {
        zoomedData: [],
        mergedExpoHedges: mergedExpoHedges,
        dDowns: this.analyticsManager.createDDowns([
          { details: mergedExpoHedges },
        ]),
        dataFilters: this.analyticsManager.defineFilters(this.customFilters),
        filteredData: mergedExpoHedges,
      });
      this.nestAndZoom(mergedExpoHedges, calculate);
    }
  }

  postAnalyticsCurrencyUpdate(_this, data, expo) {
    Object.assign(_this.Analytics["loading"], {
      management: true,
      strategies: true,
    });
    let params = {
      method: "POST",
      endpoint: "analytics_currency_update",
      content_type: "application/json",
      query_params: {
        format: "json",
        derivatives: JSON.stringify(data),
        expo: JSON.stringify(expo),
      },
    };
    return apiService
      .getAll(params)
      .then((response) => {
        this.parseManagementData(response, _this, false);
        Object.assign(_this.Analytics["loading"], {
          management: false,
          strategies: false,
        });
      })
      .catch(function(error) {
        Object.assign(_this.Analytics["loading"], {
          smanagement: false,
          strategies: false,
        });
        console.error(error);
      });
  }

  getManagementData(
    _this,
    initialDate = null,
    selectedCompanies,
    selectedAsset,
    selectedPortfolios,
  ) {
    initialDate = initialDate != null ? initialDate : new Date();
    Object.assign(this.loading, {
      budget: true,
      expo: true,
      hedges: true,
      management: true,
      pastCalcs: true,
      program: true,
      strategies: true,
      derivatives: true,
      topographyCalcs: true,
    });
    this.resetData();
    Object.assign(this.management, {
      contracts: [],
      date: [],
      date_2: [],
    });
    let params = {
      method: "POST",
      endpoint: "analytics_currency_manage",
      content_type: "application/json",
      query_params: {
        companies: {
          id_companies: selectedCompanies.map((d) => d.pk_idcompany),
        },
        date: formatDate_YMD(initialDate),
        assetsNums: {
          id_assets: selectedAsset,
        },
        format: "json",
        portfolios: {
          id_portfolios: selectedPortfolios.map((d) => d.pk),
        },
      },
    };
    apiService
      .getAll(params)
      .then((data) => {
        this.parseManagementData(data, _this);

        Object.assign(_this.Analytics["loading"], {
          budget: false,
          expo: false,
          hedges: false,
          management: false,
          pastCalcs: false, // portCalcs: true,
          program: false, // strategies: true, derivatives: true, topographyCalcs: true, topographyCalcsRates: true
        });
        Object.assign(_this.Analytics["rawData"], { toBeFetched: false });
        Object.assign(_this.Analytics["rawData"], { toBeFetchedHidden: true });
        _this.selectionStr();
      })
      .catch(function(error) {
        Object.assign(_this.Analytics["loading"], {
          budget: false,
          expo: false,
          hedges: false,
          management: false,
          pastCalcs: false,
          portCalcs: false,
          program: false,
          strategies: false,
          derivatives: false,
          topographyCalcs: false,
          topographyCalcsRates: false,
        });
        console.error("getManagementData", error);
      });
  }

  stringTitle() {
    // Companies
    const data = this;
    let txt = this.analyticsHelpers.selectionStrFct(
      data["userSelections"]["selectedCompanies"],
      "company_name",
      " companies",
    );
    // == portfolios
    if (data["rawData"]["dataFilters"]["portfolio"]["value"] != null) {
      txt +=
        " | " +
        this.analyticsHelpers.selectionStrFct(
          data["rawData"]["dataFilters"]["portfolio"]["value"],
          null,
          " portfolios",
        );
    } else {
      if (data["userSelections"]["selectedPortfolios"] != null) {
        txt +=
          " | " +
          this.analyticsHelpers.selectionStrFct(
            data["userSelections"]["selectedPortfolios"],
            "name",
            " portfolios",
          );
      }
    }
    // == currencies
    if (data["rawData"]["dataFilters"]["pk_i_idcurrency"]["value"] != null) {
      txt +=
        " | " +
        this.analyticsHelpers.selectionStrFct(
          data["rawData"]["dataFilters"]["pk_i_idcurrency"]["value"],
          null,
          " currencies",
        );
    } else {
      if (data["userSelections"]["selectedAsset"] != null) {
        txt +=
          " | " +
          this.analyticsHelpers.selectionStrFct(
            data["userSelections"]["selectedAsset"],
            "currency_name",
            " currencies",
          );
      }
    }

    return txt;
  }

  nestingQuantities(v, sign) {
    const isFixationDerivative = this.analyticsHelpers.isFixationDerivative;
    // ==== QUANTITIES  ==== ==== ==== ==== ==== ==== ==== ==== ====
    const m2m_fixedValue = sum(v, function(d) {
      return isFixationDerivative(d.derivative) ? d.hedge_value : 0;
    });
    const m2m_fixedHedgedValue = sum(v, function(d) {
      return d.hedge_value;
    });
    const m2m_hedgeValue = m2m_fixedHedgedValue - m2m_fixedValue;
    let q_budget =
      sign *
      sum(v, function(d) {
        return d.budget_expo;
      });
    const q_commited =
      sign *
      sum(v, function(d) {
        return d.balance;
      });
    const q_forecast =
      sign *
      sum(v, function(d) {
        return d.cash_flow;
      });
    const q_program =
      sign *
      sum(v, function(d) {
        return d.program ? d.program : 0;
      });
    const q_fixedHedged =
      sign *
      sum(v, function(d) {
        return d.hedgeNotional;
      });
    const q_fixed =
      sign *
      sum(v, function(d) {
        return isFixationDerivative(d.derivative) ? d.hedgeNotional : 0;
      });
    const q_hedged =
      sign *
      sum(v, function(d) {
        return !isFixationDerivative(d.derivative) ? d.hedgeNotional : 0;
      });

    q_budget = q_budget === 0 ? NaN : q_budget;
    return {
      m2m_fixedHedgedValue,
      m2m_fixedValue,
      m2m_hedgeValue,
      q_budget,
      q_commited,
      q_fixed,
      q_fixedHedged,
      q_forecast,
      q_hedged,
      q_program,
    };
  }

  nestingBudget(v, sign, q_forecast) {
    let p_budget_au =
      (sign *
        sum(v, function(d) {
          return d.cash_flow !== 0 ? d.budget_price * d.cash_flow : 0;
        })) /
      q_forecast;

    p_budget_au =
      Number.isFinite(p_budget_au) && p_budget_au !== 0
        ? p_budget_au
        : this.averageIgnoringNaN(v.map((d) => d.budget_price));
    p_budget_au = p_budget_au === 0 ? NaN : p_budget_au;

    return {
      p_budget_au,
    };
  }

  nestingMarket(v, sign, q_forecast, mktRef) {
    const p_market =
      q_forecast !== 0
        ? (sign *
            sum(v, function(d) {
              return d.cash_flow !== 0 ? d[mktRef] * d.cash_flow : 0;
            })) /
          q_forecast
        : NaN;
    return {
      p_market,
    };
  }

  nestingHedges(v, sign, q_commited, q_fixed, q_hedged, q_fixedHedged) {
    const isFixationDerivative = this.analyticsHelpers.isFixationDerivative;
    // currencies
    const p_fixed =
      (sign *
        (sum(v, function(d) {
          return isFixationDerivative(d.derivative)
            ? d.fwd * d.hedgeNotional
            : 0;
        }) +
          sum(v, function(d) {
            return isFixationDerivative(d.derivative) ? d.hedge_value : 0;
          }))) /
      q_fixed;
    const p_hedged =
      (sign *
        (sum(v, function(d) {
          return !isFixationDerivative(d.derivative)
            ? d.fwd * d.hedgeNotional
            : 0;
        }) +
          sum(v, function(d) {
            return !isFixationDerivative(d.derivative) ? d.hedge_value : 0;
          }))) /
      q_hedged;
    const p_fixedHedged =
      (sign *
        (sum(v, function(d) {
          return d.fwd * d.hedgeNotional;
        }) +
          sum(v, function(d) {
            return d.hedge_value;
          }))) /
      q_fixedHedged;

    // commited quantities
    const p_commited =
      (sign *
        sum(v, function(d) {
          return d.balance !== 0 ? d.rate_at_issue_date * d.balance : 0;
        })) /
      q_commited;

    return {
      p_commited,
      p_fixed,
      p_hedged,
      p_fixedHedged,
    };
  }

  nestingNet(
    m2m_fixedHedgedValue,
    p_commited,
    p_fixedHedged,
    p_market,
    q_fixedHedged,
    q_forecast,
    sign,
  ) {
    let weiAve = this.analyticsHelpers.weiAve;
    let p_net;
    if (
      m2m_fixedHedgedValue !== 0 &&
      Number.isNaN(p_fixedHedged) &&
      Number.isNaN(p_commited)
    ) {
      p_net =
        (p_market * q_forecast + sign * m2m_fixedHedgedValue) / q_forecast;
    } else {
      p_net = weiAve(p_fixedHedged, q_fixedHedged, p_market, q_forecast);
    }
    p_net = Number.isFinite(p_net) ? p_net : p_market;

    return { p_net };
  }

  nestingDifferences(
    p_budget,
    p_market,
    p_net,
    q_commited,
    q_fixedHedged,
    q_forecast,
    sign,
    v,
  ) {
    // Total Values ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    // 1st diff: Net vs Market
    const v_netVsMkt =
      sign *
      (p_net - p_market) *
      Math.max(q_commited, q_fixedHedged, q_forecast);

    // ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    // 2nd diff: hedge P&L
    const v_fixedHedged = sum(v, function(d) {
      return d.hedge_value;
    });

    // ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    // 3rd diff: Open Exposure:
    // For ratio: market ratio - bought/sold ratio × market futures price × unhedged quantity.
    // For basis/premium: market basis - bought/sold basis × unhedged quantity.

    // ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    // 4th diff: Net – Budget
    const v_budget =
      sign *
      (p_net - p_budget) *
      Math.max(q_commited, q_fixedHedged, q_forecast); // All

    return {
      v_netVsMkt,
      v_fixedHedged,
      v_budget,
    };
  }

  nestingChangeQty(
    q_budget,
    q_commited,
    q_fixed,
    q_fixedHedged,
    q_forecast,
    q_hedged,
    q_program,
  ) {
    const q_budgetPerc = q_budget / q_forecast;
    const q_commitedPerc = q_commited / q_forecast;
    const q_commitedPercS = q_commited / q_forecast;
    const q_programPerc = q_program / q_forecast;
    const q_fixedPerc = q_fixed / q_forecast;
    const q_fixedPercS = q_fixed / q_forecast;
    const q_hedgedPerc = q_hedged / q_forecast;
    const q_fixedHedgedPerc = q_fixedHedged / q_forecast;

    return {
      q_budgetPerc,
      q_commitedPerc,
      q_commitedPercS,
      q_fixedHedgedPerc,
      q_fixedPerc,
      q_fixedPercS,
      q_hedgedPerc,
      q_programPerc,
    };
  }

  nestingChangePr(
    p_budget,
    p_commited,
    p_fixed,
    p_fixedHedged,
    p_hedged,
    p_market,
    p_net,
  ) {
    // ==== PRICES ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    const p_fixedPerc = p_fixed / p_budget - 1;
    const p_fixedHedgedPerc = p_fixedHedged / p_budget - 1;
    const p_commitedPerc = p_commited / p_budget - 1;
    const p_hedgedPerc = p_hedged / p_budget - 1;
    const p_marketPerc = p_market / p_budget - 1;
    const p_netPerc = p_net / p_budget - 1;

    return {
      p_commitedPerc,
      p_fixedHedgedPerc,
      p_fixedPerc,
      p_hedgedPerc,
      p_marketPerc,
      p_netPerc,
    };
  }

  /** processes a set of data to calculate quantities, normalized percentages, prices, etc. */
  nestingMainCalcs(v, intervalGroup, data, sign) {
    const date = this.analyticsHelpers.timeComparison(
      values(v).pop().date,
      intervalGroup,
      data,
    );
    // exportToCSV(v, 'data_to_nest.csv')
    // ==== QUANTITIES  ==== ==== ==== ==== ==== ==== ==== ==== ====
    const {
      m2m_fixedHedgedValue,
      m2m_fixedValue,
      m2m_hedgeValue,
      q_budget,
      q_commited,
      q_fixed,
      q_fixedHedged,
      q_forecast,
      q_hedged,
      q_program,
    } = this.nestingQuantities(v, sign);

    // ==== BUDGET ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    const { p_budget_au } = this.nestingBudget(v, sign, q_forecast);
    let p_budget = +p_budget_au;

    // MARKET ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    const mktRef =
      this.userSelections.mktRef === "spot"
        ? "fwd"
        : this.userSelections.mktRef === "1W"
        ? "settle_ma_5"
        : this.userSelections.mktRef === "2W"
        ? "settle_ma_10"
        : this.userSelections.mktRef === "1M"
        ? "settle_ma_20"
        : "fwd";
    const {
      p_market,
      p_marketBasis,
      p_marketFut,
      p_marketOther,
      p_marketRatio,
    } = this.nestingMarket(v, sign, q_forecast, mktRef);
    p_budget = Number.isFinite(p_budget) ? p_budget : p_market;

    // FIXED & HEDGED prices ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    const { p_commited, p_fixed, p_hedged, p_fixedHedged } = this.nestingHedges(
      v,
      sign,
      q_commited,
      q_fixed,
      q_hedged,
      q_fixedHedged,
    );

    // NET ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    const { p_net } = this.nestingNet(
      m2m_fixedHedgedValue,
      p_commited,
      p_fixedHedged,
      p_market,
      q_fixedHedged,
      q_forecast,
      sign,
    );

    // Total Values ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    const { v_netVsMkt, v_fixedHedged, v_budget } = this.nestingDifferences(
      p_budget,
      p_market,
      p_net,
      q_commited,
      q_fixedHedged,
      q_forecast,
      sign,
      v,
    );

    // CHANGES ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    // ==== QUANTITIES ==== ==== ==== ==== ==== ==== ==== ====
    const {
      q_budgetPerc,
      q_commitedPerc,
      q_commitedPercS,
      q_fixedHedgedPerc,
      q_fixedPerc,
      q_fixedPercS,
      q_hedgedPerc,
      q_programPerc,
    } = this.nestingChangeQty(
      q_budget,
      q_commited,
      q_fixed,
      q_fixedHedged,
      q_forecast,
      q_hedged,
      q_program,
    );
    // ==== PRICES ==== ==== ==== ==== ==== ==== ==== ====
    const {
      p_commitedPerc,
      p_fixedHedgedPerc,
      p_fixedPerc,
      p_hedgedPerc,
      p_marketPerc,
      p_netPerc,
    } = this.nestingChangePr(
      p_budget,
      p_commited,
      p_fixed,
      p_fixedHedged,
      p_hedged,
      p_market,
      p_net,
    );
    return {
      date: date,
      m2m_fixedHedgedValue: m2m_fixedHedgedValue,
      m2m_fixedValue: m2m_fixedValue,
      m2m_hedgeValue: m2m_hedgeValue,
      p_budget: p_budget,
      p_commited: p_commited,
      p_commitedPerc: p_commitedPerc,
      p_fixed: p_fixed,
      p_fixedHedged: p_fixedHedged,
      p_fixedHedgedPerc: p_fixedHedgedPerc,
      p_fixedPerc: p_fixedPerc,
      p_hedged: p_hedged,
      p_hedgedPerc: p_hedgedPerc,
      p_market: p_market,
      p_marketBasis: p_marketBasis,
      p_marketFut: p_marketFut,
      p_marketOther: p_marketOther,
      p_marketPerc: p_marketPerc,
      p_marketRatio: p_marketRatio,
      p_net: p_net,
      p_netPerc: p_netPerc,
      q_budget: q_budget,
      q_budgetPerc: q_budgetPerc,
      q_commited: q_commited,
      q_commitedPerc: q_commitedPerc,
      q_commitedPercS: q_commitedPercS,
      q_fixed: q_fixed,
      q_fixedHedged: q_fixedHedged,
      q_fixedHedgedPerc: q_fixedHedgedPerc,
      q_fixedPerc: q_fixedPerc,
      q_fixedPercS: q_fixedPercS,
      q_forecast: q_forecast,
      q_hedged: q_hedged,
      q_hedgedPerc: q_hedgedPerc,
      q_program: q_program,
      q_programPerc: q_programPerc,
      v_budget: v_budget,
      v_fixedHedged: v_fixedHedged,
      v_netVsMkt: v_netVsMkt,
      zeroFld: 0,
    };
  }
}

export const managementFields = [
  {
    id: 0,
    dataType: "",
    field: "contract_month_year",
    header: "Contract",
    styles: { "max-width": "6rem" },
  },
  {
    id: 1,
    dataType: "",
    field: "custom_name",
    header: "ID",
    styles: { width: "5rem" },
  },
  {
    id: 2,
    dataType: "date",
    field: "date",
    header: "Date",
    styles: { width: "6rem" },
  },
  {
    id: 3,
    dataType: "",
    field: "end_product_str",
    header: "Product",
    styles: { width: "9rem" },
  },
  {
    id: 4,
    dataType: "number",
    field: "cash_flow_ch",
    header: "Req. Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 5,
    dataType: "",
    field: "supplier",
    header: "Supplier",
    styles: { width: "5rem" },
  },
  {
    id: 6,
    dataType: "",
    field: "client_str",
    header: "Client",
    styles: { width: "9rem" },
  },
  {
    id: 7,
    dataType: "",
    field: "business",
    header: "Business",
    styles: { width: "5rem" },
  },
  {
    id: 8,
    dataType: "",
    field: "fk_id_plant",
    header: "Plant",
    styles: { width: "5rem" },
  },
  {
    id: 9,
    dataType: "",
    field: "fk_id_port",
    header: "Port",
    styles: { width: "5rem" },
  },
  {
    id: 10,
    dataType: "number",
    field: "hedgeNotional_ch",
    header: "Hedged. Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 11,
    dataType: "priceNone",
    field: "base",
    header: "Basis",
    styles: { "max-width": "5rem" },
  },
  {
    id: 12,
    dataType: "priceNone",
    field: "ratio",
    header: "Ratio",
    styles: { "max-width": "5rem" },
  },
  {
    id: 13,
    dataType: "",
    field: "contract_month_year_hedge",
    header: "Future",
    styles: { width: "5rem" },
  },
  {
    id: 14,
    dataType: "",
    field: "strategy_name",
    header: "Strategy",
    styles: { width: "10rem" },
  },
  {
    id: 15,
    dataType: "",
    field: "counterparty",
    header: "Counterparty",
    styles: { width: "7rem" },
  },
  {
    id: 16,
    dataType: "",
    field: "buy_sell",
    header: "Position",
    styles: { "max-width": "5rem" },
  },
  {
    id: 17,
    dataType: "",
    field: "derivative",
    header: "Derivative",
    styles: { width: "5rem" },
  },
  {
    id: 18,
    dataType: "number",
    field: "hedge_value",
    header: "Mark 2 Mkt",
    styles: { width: "7rem" },
  },
  {
    id: 19,
    dataType: "number",
    field: "delta_ch",
    header: "Delta Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 20,
    dataType: "priceNone",
    field: "spot",
    header: "Mkt Price",
    styles: { "max-width": "6rem" },
  },
  {
    id: 21,
    dataType: "price",
    field: "strategy_value",
    header: "Strategy Value",
    styles: { width: "6rem" },
  },
  {
    id: 22,
    dataType: "price",
    field: "strike",
    header: "Strike",
    styles: { "max-width": "6rem" },
  },
  {
    id: 23,
    dataType: "date",
    field: "trade_date",
    header: "Trade Date",
    styles: { "max-width": "6rem" },
  },
  {
    id: 24,
    dataType: "",
    field: "weighted_strikes",
    header: "Details",
    styles: { width: "12rem" },
  },
  {
    id: 25,
    dataType: "number",
    field: "quantity_hedge",
    header: "Strat. Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 26,
    dataType: "",
    field: "strategy_w_code",
    header: "Strategy",
    styles: { width: "5rem" },
  },
  {
    id: 27,
    dataType: "",
    field: "custom_id",
    header: "Expo ID",
    styles: { width: "8rem" },
  },
  {
    id: 28,
    dataType: "number",
    field: "expoQ",
    header: "-No- Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 29,
    dataType: "futDate",
    field: "monthDate",
    header: "Month",
    styles: { "max-width": "5rem" },
  },
  {
    id: 30,
    dataType: "",
    field: "show",
    header: "Show",
    styles: { width: "5rem" },
  },
  {
    id: 31,
    dataType: "",
    field: "status",
    header: "Status",
    styles: { "max-width": "6rem" },
  },
  {
    id: 32,
    dataType: "date",
    field: "fixing_date",
    header: "Fixing Date",
    styles: { "max-width": "6rem" },
  },
  {
    id: 33,
    dataType: "number",
    field: "balance_ch",
    header: "Locked Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 34,
    dataType: "",
    field: "q_min_max",
    header: "Min | Max Q",
    styles: { "max-width": "7rem" },
  },
  {
    id: 35,
    dataType: "number",
    field: "q_current_ch",
    header: "Accum. Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 36,
    dataType: "priceNone",
    field: "strategy_strike",
    header: "Strat. Price",
    styles: { "max-width": "6rem" },
  },
  {
    id: 37,
    dataType: "date",
    field: "fixation_date",
    header: "Contract Date",
    styles: { "max-width": "7rem" },
  },
  {
    id: 38,
    dataType: "priceNone",
    field: "budget_futures",
    header: "Ref. Price",
    styles: { "max-width": "6rem" },
  },
  {
    id: 39,
    dataType: "",
    field: "commodity",
    header: "Cmdty",
    styles: { width: "6rem" },
  },
];
